import { ChevronUp,AlertTriangle,ChevronDown } from "lucide-react";


// Alarms Panel Component
export const AlarmsPanel = ({ alarms, isExpanded, onToggle }) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <button 
        onClick={onToggle}
        className="w-full flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
      >
        <div className="flex items-center gap-2">
          <AlertTriangle size={18} className="text-yellow-600" />
          <h3 className="text-sm font-semibold text-gray-800">Alarms</h3>
          {alarms.length > 0 && (
            <span className="px-2 py-0.5 bg-yellow-100 text-yellow-700 text-xs rounded-full font-medium">
              {alarms.length}
            </span>
          )}
        </div>
        {isExpanded ? <ChevronUp size={18} className="text-gray-400" /> : <ChevronDown size={18} className="text-gray-400" />}
      </button>
      {isExpanded && (
        <div className="px-4 pb-4 space-y-2 max-h-64 overflow-y-auto">
          {alarms.length > 0 ? (
            alarms.map((alarm) => (
              <div 
                key={alarm.id}
                className={`text-xs text-gray-700 py-2.5 px-3 rounded border-l-4 ${
                  alarm.type === 'emergency' 
                    ? 'bg-red-50 border-red-500' 
                    : alarm.type === 'maintenance'
                    ? 'bg-blue-50 border-blue-500'
                    : 'bg-yellow-50 border-yellow-500'
                }`}
              >
                <div className="flex items-start justify-between gap-2">
                  <div className="flex-1">
                    <div className="font-medium mb-0.5">
                      {alarm.type === 'emergency' ? '🚨 Emergency' : alarm.type === 'maintenance' ? '🔧 Maintenance' : '⚠️ Warning'}
                    </div>
                    <div>{alarm.message}</div>
                  </div>
                  {alarm.time && (
                    <span className="text-xs text-gray-500 whitespace-nowrap">{alarm.time}</span>
                  )}
                </div>
              </div>
            ))
          ) : (
            <div className="text-xs text-gray-500 text-center py-4">
              No alarms at this time
            </div>
          )}
        </div>
      )}
    </div>
  );
};